/* src/app/private/components/leads/add-lead/add-lead.component.scss */
label {
  font-weight: 500;
  margin-bottom: 5px;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=add-lead.component.css.map */
